import React, {  useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';

import { useNotification } from 'config/Notification';

import { fetchPDFReportsBYID as fetchPDFReportsBYIDService, fetchPDFReports as fetchPDFReportsService } from 'services/modules/ecs/report';

import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import { 
  Button, 
  FormControl,
  FormHelperText,
  InputLabel, 
  MenuItem, 
  Select  
} from '@mui/material';

const ViewReport = ({ toggleSummaryReport }) => {
    // State Variables
    const [companyData, setCompanyData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [selectedReportId, setSelectedReportId] = useState(null);
    const [show, setShow] = useState(true);
    const [touched, setTouched] = useState(false);

    // Navigate
    const navigate=useNavigate();

    //Notification
    const {openNotification}=useNotification();
    
    // This method shows the available PPT reports for the user.
    const handleOpen = () => {
      if (companyData.length > 0) {
        setOpen(true);
      }
      else
      {
        openNotification('PPT report ids are not available for this user','error')
      }
    };
  
    // Method to fetch the available reports for company
    const fetchSummaryReportData= async () => {
      try 
      {  
        setLoading(true);
        const response = await fetchPDFReportsService();
        if (Array.isArray(response.data)) {
          setCompanyData(response.data);
        } else {
          openNotification("Invalid data",'error');
        }
      } 
      catch (error) {
        openNotification("Error fetching report:", 'error');
      } 
      finally {
        setLoading(false);
        setOpen(false)  
      }
    };

    // This method used to view the report
    const viewPDF = async () => {
      try 
      {
        setLoading(true);
        if(selectedReportId===null){
          openNotification('Please select a report id','error');
          return;
        }
        const excelResponse =  await fetchPDFReportsBYIDService({selectedReportId})

        if(selectedReportId!==null){
          navigate('/crs/viewpdf', { state: { fileData: excelResponse.data } });
        }
      } 
      catch (error) {
        openNotification("Data is not fetched",'error');
      } 
      finally {
        setLoading(false);
        setShow(false);
      }
    };
  
    // Method handles the download button of reports
    const handleDownloadExcel = async () => {
      try 
      {
        if(selectedReportId===null){ 
          openNotification('Please select a report id','error');
          return;
        }
        const excelResponse = await fetchPDFReportsBYIDService({selectedReportId});
        const fileUrl = excelResponse.data.url;
        window.open(fileUrl, '_blank');
      } 
      catch (error) {
        openNotification("Data is not fetched",'error');
      }
      finally {
        setShow(false);
      }
    };

    useEffect(() => {
      fetchSummaryReportData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    // Method to close the Summary Report
    function closing(){
      setShow(false);
      toggleSummaryReport();
    }

  return (
    <Modal show={show} onHide={closing} dialogClassName="modal-90w"  animation={false}>
      <Modal.Header className="space-between" closeButton>
        <Modal.Title  className="report-modal">
          <LibraryBooksIcon className="m-1" />
          <h4 className="report-heading-1">ECS pdf report</h4>
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {loading ? (
          <div className="loader-container">
            <div className="spinner-border text-primary loader" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="report-modal-buttons">
              <FormControl className='report-form'>
                <InputLabel >Report id</InputLabel>
                <Select  label="Report ID" value={selectedReportId} open={open} onOpen={handleOpen} onClose={() => setOpen(false)}
                  onChange={(e) => {
                    setSelectedReportId(e.target.value);
                    setTouched(true);
                  }}
                >
                  {companyData.map((report, index) => (
                    <MenuItem key={index} value={report.id}>{report.reportId}</MenuItem>
                  ))}
                </Select>
      
                {selectedReportId === null && touched && (
                  <FormHelperText error>Please select a report id.</FormHelperText>
                )}
              </FormControl>
            </div>

            <div className="report-modal-buttons">
              <Button variant="outlined" className="viewreport-btn" onClick={viewPDF}>
                <LibraryBooksIcon className="m-1" /> View report
              </Button>
              <Button variant="outlined" className="downloadreport-btn" onClick={handleDownloadExcel}>
                <LibraryBooksIcon className="m-1" /> Download report
              </Button>
            </div>
            
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewReport;